"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var util_1 = require("util");
var notification_1 = __importDefault(require("../../helpers/notification"));
var Form_1 = __importDefault(require("../Form"));
var Table_1 = __importDefault(require("../Table"));
var TableActions_1 = __importDefault(require("./TableActions"));
var TableCell_1 = __importDefault(require("./TableCell"));
var TableContext_1 = __importDefault(require("./TableContext"));
var TableRow_1 = __importDefault(require("./TableRow"));
var mountColumns = function (columns) {
    var resolvedColumns = columns.map(function (col) { return (__assign({}, col, { onCell: function (record) { return ({
            record: record,
            dataIndex: col.dataIndex,
            title: col.title,
            renderEdit: col.renderEdit,
        }); } })); });
    resolvedColumns.push({
        title: 'ui.commons.actions',
        dataIndex: 'actions',
        render: function (_, record) { return react_1.default.createElement(TableActions_1.default, { record: record }); },
    });
    return resolvedColumns;
};
var components = {
    body: {
        row: TableRow_1.default,
        cell: TableCell_1.default,
    },
};
var InlineEditTable = function (props) {
    var dataSource = props.dataSource, columns = props.columns, updateItem = props.updateItem, deleteItem = props.deleteItem, rowKey = props.rowKey, tableProps = __rest(props, ["dataSource", "columns", "updateItem", "deleteItem", "rowKey"]);
    var _a = react_1.useState(undefined), editing = _a[0], setEditing = _a[1];
    var _b = react_1.useState(dataSource || []), dataState = _b[0], setDataState = _b[1];
    var resolvedColumns = react_1.useMemo(function () { return mountColumns(columns); }, [columns]);
    react_1.useEffect(function () { return setDataState(dataSource || []); }, [dataSource]);
    var extractId = react_1.useCallback(function (record) {
        if (rowKey) {
            if (util_1.isString(rowKey))
                return record[rowKey];
            if (util_1.isFunction(rowKey))
                return rowKey(record);
        }
        return record.id;
    }, [rowKey]);
    var handleDelete = react_1.useCallback(function (record) { return __awaiter(_this, void 0, void 0, function () {
        var itemId_1, ok, newData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!deleteItem) return [3, 2];
                    itemId_1 = extractId(record);
                    return [4, deleteItem(extractId(record))];
                case 1:
                    ok = _a.sent();
                    if (ok) {
                        newData = dataState.filter(function (i) { return extractId(i) !== itemId_1; });
                        setDataState(newData);
                        notification_1.default.success('ui.message.api.delete.success');
                    }
                    _a.label = 2;
                case 2: return [2];
            }
        });
    }); }, [deleteItem, dataState, extractId]);
    var handleUpdate = react_1.useCallback(function (values) { return __awaiter(_this, void 0, void 0, function () {
        var itemId, ok, newData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    itemId = extractId(values);
                    return [4, updateItem(values)];
                case 1:
                    ok = _a.sent();
                    if (ok) {
                        newData = dataState.map(function (i) { return (extractId(i) !== itemId ? i : __assign({}, i, values)); });
                        setDataState(newData);
                        notification_1.default.success('ui.message.api.save.success');
                    }
                    setEditing(undefined);
                    return [2];
            }
        });
    }); }, [updateItem, dataState, extractId]);
    var tableContext = react_1.useMemo(function () {
        return {
            editing: editing,
            isEditing: function (record) { return !!editing && !!record && extractId(record) === extractId(editing); },
            setEditing: setEditing,
            handleDelete: deleteItem && handleDelete,
        };
    }, [editing, extractId, handleDelete, deleteItem]);
    return (react_1.default.createElement(Form_1.default, { onSubmit: handleUpdate, initialValues: editing },
        react_1.default.createElement(TableContext_1.default.Provider, { value: tableContext },
            react_1.default.createElement(Table_1.default, __assign({ components: components, dataSource: dataState, columns: resolvedColumns, onRow: function (record) { return ({
                    record: record,
                }); }, rowKey: extractId }, tableProps)))));
};
exports.default = InlineEditTable;
